import React from 'react'
import PropTypes from 'prop-types'
import { api } from 'components/api'
import { commodityCodesPath } from 'components/routes/api'
import Segment from './picker/Segment'
import CloseInfoBox from 'images/supplier_commodity_picker/close-info-box.svg'
import InfoI from 'images/supplier_commodity_picker/info-i.svg'
import SegmentShape from './prop_shapes/segment'
import FamilyShape from './prop_shapes/family'
import CommodityClassShape from './prop_shapes/commodity_class'

class Picker extends React.Component {
  constructor (props) {
    super(props)
    this.abortController = new window.AbortController()
    this.abortReason = 'Commodity Code Picker component failed fetch'
    this.state = {
      displayInfo: true,
      expandedSegmentCode: null,
      segments: []
    }
  }

  componentDidMount () {
    api.get({
      url: commodityCodesPath(),
      headers: {
        Accept: 'application/json'
      },
      signal: this.abortController.signal
    })
      .then(response => {
        this.setState({ segments: response.data })
      })
      .catch(({ name, config }) => {
        if (name === 'CanceledError' && config?.signal?.reason === this.abortReason) { return }
        console.error(`Error while fetching ${commodityCodesPath()}`)
      })
  }

  componentWillUnmount () {
    this.abortController.abort(this.abortReason)
  }

  handleCloseClick = () => this.setState({ displayInfo: false })

  toggleSegmentSelected = segment => {
    if (this.props.selectedSegments.find((selectedSegment) => selectedSegment.id === segment.id)) {
      this.props.deselectSegment(segment)
    } else {
      this.props.selectSegment(segment)
    }
  }

  setExpandedSegmentCode = code => {
    this.setState({ expandedSegmentCode: code })
  }

  renderInfoBox = () => {
    return this.state.displayInfo
      ? (
        <div id='unspsc-info' className='grid-x grid-padding-x'>
          <div className='small-1 cell align-self-middle'>
            <img src={InfoI} />
          </div>
          <div className='auto cell'>
            <p>UNSPSC Codes are organized as a hierarchy: <strong>Segment &gt; Family &gt; Class</strong></p>
            <p className='detail'>Example: Apparel and Luggage and Personal Care Products &gt; Clothing &gt; Uniforms. Make specific selections at the Class level or use the Family to select all Classes within that Family</p>
          </div>
          <div className='shrink cell'>
            <button className='close' onClick={this.handleCloseClick}>
              <img src={CloseInfoBox} />
            </button>
          </div>
        </div>
        )
      : null
  }

  selectSegment = segment => {
    this.props.updateSelectedSegment({
      ...segment,
      all_families_selected: true,
      families: segment.families.map((family) => {
        return { ...family, all_classes_selected: true }
      })
    })
  }

  deselectSegment = segment => {
    this.props.removeSelectedSegment(segment)
  }

  selectedFamiliesFor = segment => {
    const selectedSegment = this.props.selectedSegments.find(selectedSegment => selectedSegment.id === segment.id)

    if (selectedSegment && selectedSegment.families && selectedSegment.families.length > 0) {
      return selectedSegment.families
    } else {
      return []
    }
  }

  segmentOrSelectedSegment = segment => {
    return this.props.selectedSegments.find(selectedSegment => selectedSegment.id === segment.id) || segment
  }

  render () {
    return (
      <>
        {this.renderInfoBox()}
        <div id='picker' aria-label='Select commodity codes' key='commodity-code-picker'>
          {this.state.segments.map(segment =>
            <Segment
              segment={this.segmentOrSelectedSegment(segment)}
              key={segment.code}
              setExpandedSegmentCode={this.setExpandedSegmentCode}
              setActiveCode={this.props.setActiveCode}
              isActiveCode={this.props.isActiveCode}
              isInActiveCodeHierarchy={this.props.isInActiveCodeHierarchy}
              expanded={this.state.expandedSegmentCode === segment.code}
              selectedFamilies={this.selectedFamiliesFor(segment)}
              toggleSegmentSelected={this.toggleSegmentSelected}
              updateSelectedSegment={this.props.updateSelectedSegment}
              selectSegment={this.selectSegment}
              deselectSegment={this.deselectSegment}
            />
          )}
        </div>
      </>
    )
  }
}

export default Picker

Picker.propTypes = {
  selectedSegments: PropTypes.arrayOf(SegmentShape).isRequired,
  activeCode: PropTypes.oneOfType([SegmentShape, FamilyShape, CommodityClassShape]),
  setActiveCode: PropTypes.func.isRequired,
  deselectSegment: PropTypes.func.isRequired,
  selectSegment: PropTypes.func.isRequired,
  updateSelectedSegment: PropTypes.func.isRequired,
  removeSelectedSegment: PropTypes.func.isRequired,
  isActiveCode: PropTypes.func.isRequired,
  isInActiveCodeHierarchy: PropTypes.func.isRequired
}

Picker.defaultProps = {
  selectedSegments: [],
  activeCode: null
}
